import { takeLatest, call, put } from 'redux-saga/effects'
import * as actions from './actions'
import notifications from '../../lib/notifications'

import Api from '../../lib/api'
import { toCamelCase } from '../../lib/converter'
import { vendorsGetRequest } from '../vendors/actions'
import { activateNetworkCheckboxIntegration, inactivateNetworkCheckboxIntegration } from '../networks/actions'

export default function* watchSaga() {
  yield takeLatest(actions.CHECKBOX_INTEGRATION_GET_REQUEST, watchResourcesGetRequest)
  yield takeLatest(actions.CHECKBOX_INTEGRATION_UPDATE_REQUEST, watchResourceUpdateRequest)
}

function* watchResourcesGetRequest() {
  try {
    const response = yield call(Api.Fiscalization.get)

    yield put(actions.checkboxIntegrationGetSuccess(toCamelCase(response.data)))
  } catch (error) {
    yield put(actions.checkboxIntegrationGetFailure(error))
    notifications.createNotification('error', error.response.data.errors)
  }
}

function* watchResourceUpdateRequest({ payload }) {
  try {
    const response = yield call(Api.Fiscalization.update, payload)
    yield payload.checkboxIntegration.checkboxIntegrated
      ? put(activateNetworkCheckboxIntegration())
      : put(inactivateNetworkCheckboxIntegration())
    yield put(actions.checkboxIntegrationUpdateSuccess(toCamelCase(response.data)))
    yield put(vendorsGetRequest({ city: '' }))
    notifications.createNotification('edit-success')
  } catch (error) {
    yield put(actions.checkboxIntegrationUpdateFailure(error))
    notifications.createNotification('error', error.response.data.errors)
  }
}
